import logo from "../logo.svg";
import "../App.css";
import { useEffect } from "react";
import "../styles.css";

function Ali() {
  useEffect(() => {
    // insert script tag
    const script = document.createElement("script");
    script.src =
      "https://dev-donation-elements-ba-donationelementsjsfilesb-1lgdmjudjjwlq.s3.us-east-2.amazonaws.com/bundle.js";
    // add charitystack-embed as id
    script.id = "charitystack-embed";
    // set data-id to M_dby7G6Xtc5
    script.dataset.id = "M_dby7G6Xtc5";
    // make script defer
    script.defer = true;
    // append script to head
    document.body.appendChild(script);

    // create an event listener that listens for a message from the iframe
    window.addEventListener("message", (event) => {
      if (event.data.action !== "IFRAME_LOADED") {
        return;
      }
      const data = JSON.parse(event.data.data);
      const iframeID = data.elementID;
      const iframe = document.getElementById(iframeID);

      // Check if iframe exists before trying to access it
      if (!iframe) {
        console.warn(`Iframe with ID ${iframeID} not found`);
        return;
      }

      // store css content from styles.css into a variable
      const cssContent = `                 
                #57f555bd-771f-4992-a749-65a98e5f328d-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
                    #dcb87a10-4825-48a6-b005-970db53cf45f-CS-fundraising-bar-pill-text-right {
                    opacity: 0 !important;
                }
            `;

      // send CSS content to iframe
      iframe.contentWindow.postMessage(
        {
          action: "ADD_CSS_CONTENT",
          entity: "CHARITYSTACK",
          sender: "PARENT_WEBSITE",
          receiver: "FUNDRAISING_BAR",
          data: cssContent,
          id: iframeID,
        },
        "*",
      );
    });
  }, []);

  return (
    <div className="App">
      {/* <div
                style={{
                    position: "fixed",
                    top: "0px",
                    width: "100%",
                    height: "100px",
                    background: "linear-gradient(to bottom, #0066ff, #ff0000)",
                    zIndex: "99999",
                }}></div> */}

      <div>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
        sollicitudin enim et dolor pellentesque, et aliquam velit vestibulum.
        Morbi condimentum felis eget tortor congue, id convallis turpis
        fringilla. Duis rutrum tellus et sapien
      </div>
      <button
        onClick={() => window.CharityStack?.openUserLogin()}
        style={{
          backgroundColor: "#488338",
          color: "white",
          border: "none",
          borderRadius: "9999px",
          padding: "10px 20px",
          fontSize: "14px",
          fontWeight: 500,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
        >
          <circle cx="12" cy="8" r="5" />
          <path d="M20 21a8 8 0 0 0-16 0" />
        </svg>
        My Account
      </button>
      <div
        data-entity="EMBED_FORM"
        data-source="CharityStack"
        id="8a4bc37f-2200-4c2c-b12a-b005bcd37e0b"
      ></div>
    </div>
  );
}

export default Ali;
